"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicinalProductPharmaceutical_RouteOfAdministration = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Ratio_1 = require("./RTTI_Ratio");
var RTTI_Duration_1 = require("./RTTI_Duration");
var RTTI_MedicinalProductPharmaceutical_TargetSpecies_1 = require("./RTTI_MedicinalProductPharmaceutical_TargetSpecies");
exports.RTTI_MedicinalProductPharmaceutical_RouteOfAdministration = t.recursion('IMedicinalProductPharmaceutical_RouteOfAdministration', function () {
    return t.intersection([
        t.type({
            code: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            firstDose: RTTI_Quantity_1.RTTI_Quantity,
            maxSingleDose: RTTI_Quantity_1.RTTI_Quantity,
            maxDosePerDay: RTTI_Quantity_1.RTTI_Quantity,
            maxDosePerTreatmentPeriod: RTTI_Ratio_1.RTTI_Ratio,
            maxTreatmentPeriod: RTTI_Duration_1.RTTI_Duration,
            targetSpecies: t.array(RTTI_MedicinalProductPharmaceutical_TargetSpecies_1.RTTI_MedicinalProductPharmaceutical_TargetSpecies)
        })
    ]);
});
//# sourceMappingURL=RTTI_MedicinalProductPharmaceutical_RouteOfAdministration.js.map